import request from "@/utils/request";

export function getDetail(data) {
	return request({
		url: '/app/user/hetong',
		method: 'post',
		data
	})
}
